import resolvePath from 'utils/resolvePath';

const map = <T, R>(items: T[], iterator: ((item: T) => R) | string): R[] =>
  items.map((item) => (typeof iterator === 'string' ? resolvePath(item as object, iterator) : iterator(item)));

export default map;
